/* eslint-disable */
import React from "react";
import { connect } from "react-redux";
import Loading from "react-fullscreen-loading";
import { ElementsConsumer, PaymentElement } from "@stripe/react-stripe-js";

import { loginCheckout } from "../../store/middleware";

class CheckoutForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  loadingOff() {
    this.setState({ loading: false });
  }

  loadingOn() {
    this.setState({ loading: true });
  }

  handleLogin = async () => {
    const { loginUser, login } = this.props;

    await login({ strategy: "lingo", email: loginUser.email, password: loginUser.password })
      .then(() => console.log("handleLogin checkout"))
      .catch(() => (window.location.href = "/login"));
  };

  handleSubmit = async (event) => {
    const {
      type,
      stripe,
      planId,
      priceId,
      elements,
      changeType,
      customerId,
      clientSecret,
      cardPay,
      changeTypeAt,
      studentPlanId,
      subscriptionId,
      setModalAlert,
    } = this.props;
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const that = this;
    that.loadingOn();

    if (type === "checkout") {
      // compra de novo plano
      stripe
        .confirmPayment({
          elements,
          //clientSecret,
          confirmParams: {
            // Return URL where the customer should be redirected after the SetupIntent is confirmed.
            return_url: "https://lingofor.me",
          },
          redirect: "if_required",
        })
        .then(async function (result) {
          if (result.error) {
            result.error.message === "Your card is not supported."
              ? setModalAlert({
                  show: true,
                  titleButton: "BTN_CLOSE",
                  title: "INVALID_FORM_TITLE",
                  description: "CHANGE_CARD_ERROR",
                })
              : result.error.message,
              that.loadingOff();
          } else {
            if (result.paymentIntent) {
              let status = result.paymentIntent.status;
              if (status === "succeeded") {
                // Ja temos o payment_method, só mandar pra API
                let payment_method = result.paymentIntent.payment_method;

                await fetch(`${process.env.REACT_APP_LINK_API}/subscriptions-stripe/set-subscription-payment-method`, {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    paymentMethod: payment_method,
                    subscriptionId: subscriptionId,
                    customerId: customerId,
                  }),
                })
                  .then((res) => res.json())
                  .then(async (res) => {
                    // Ativa o plano do aluno
                    let clientSecret = result.paymentIntent.client_secret;
                    await fetch(
                      `${process.env.REACT_APP_LINK_API}/subscriptions-stripe/confirmSubscription?token=${clientSecret}`,
                      {
                        method: "GET",
                        headers: { "Content-Type": "application/json" },
                      },
                    );
                    return res;
                  })
                  .then(() => {
                    if (changeType === "checkout") {
                      setModalAlert({
                        show: true,
                        titleButton: "OK",
                        title: "THANKS",
                        description: "WELCOME_TO_LINGO_CHANGE",
                      });
                    } else {
                      that.handleLogin();
                    }
                  })
                  .finally(() => that.loadingOff());
              }
            } else {
              alert("Houve um problema ao processar o cartão. Tente novamente.");
            }
          }
        });
    } else if (type === "upgradeDdowngrade") {
      // downgrade e upgrade
      /* O meio de pagamento pode ser o mesmo (current), neste caso não precisa de checkout... não precisaremos deste componente eu acho.. só chamar o backend "/subscriptions-stripe/change-plan" */
      if (cardPay !== "current") {
        stripe
          .confirmSetup({
            elements,
            //clientSecret,
            confirmParams: {
              // Return URL where the customer should be redirected after the SetupIntent is confirmed.
              return_url: "https://lingofor.me",
            },
            redirect: "if_required",
          })
          .then(function (result) {
            if (result.error) {
              result.error.message === "Your card is not supported."
                ? setModalAlert({
                    show: true,
                    titleButton: "BTN_CLOSE",
                    title: "INVALID_FORM_TITLE",
                    description: "CHANGE_CARD_ERROR",
                  })
                : result.error.message;
            } else {
              if (result.setupIntent) {
                let status = result.setupIntent.status;
                if (status === "succeeded") {
                  // Ja temos o payment_method, só mandar pra API
                  let payment_method = result.setupIntent.payment_method;

                  fetch(`${process.env.REACT_APP_LINK_API}/subscriptions-stripe/change-plan`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                      changeType: changeType,
                      changeTypeAt: changeTypeAt,
                      studentPlanId: Number(studentPlanId),
                      newPlanId: planId,
                      newPlanPriceId: priceId,
                      paymentMethod: payment_method, // "current"
                      coupon: null,
                    }),
                  })
                    .then((res) => res.json())
                    .then((res) => that.loadingOff())
                    .then((res) =>
                      setModalAlert({
                        show: true,
                        titleButton: "OK",
                        title: "THANKS",
                        description: "WELCOME_TO_LINGO_CHANGE",
                      }),
                    );
                }
              } else {
                alert("Houve um problema ao processar o cartão. Tente novamente.");
              }
            }
          });
      } else {
        fetch(`${process.env.REACT_APP_LINK_API}/subscriptions-stripe/change-plan`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            changeType: changeType,
            changeTypeAt: changeTypeAt,
            studentPlanId: studentPlanId,
            newPlanId: planId,
            newPlanPriceId: priceId,
            paymentMethod: cardPay, // "current"
            coupon: null,
          }),
        })
          .then((res) => res.json())
          .then((res) => that.loadingOff())
          .then((res) =>
            setModalAlert({
              show: true,
              titleButton: "OK",
              title: "THANKS",
              description: "WELCOME_TO_LINGO_CHANGE",
            }),
          );
      }
    }
  };

  render() {
    const { cardPay } = this.props;
    return (
      <>
        {cardPay !== "current" ? (
          <>
            <Loading loading={this.state.loading} background="rgba(0,0,0,0.6)" loaderColor="#3498db" />

            <form onSubmit={this.handleSubmit} style={{ width: "100%" }}>
              <PaymentElement />
              <button id="btn-stripe-checkout" disabled={!this.props.stripe} style={{ opacity: 0 }}>
                Submit
              </button>
            </form>
          </>
        ) : (
          <></>
        )}
      </>
    );
  }
}

function InjectedCheckoutForm(props) {
  const {
    type,
    planId,
    priceId,
    login,
    loginUser,
    clientSecret,
    changeType,
    changeTypeAt,
    subscriptionId,
    studentPlanId,
    cardPay,
    setModalAlert,
  } = props;

  return (
    <ElementsConsumer>
      {({ stripe, elements }) => (
        <CheckoutForm
          type={type}
          login={login}
          stripe={stripe}
          planId={planId}
          cardPay={cardPay}
          priceId={priceId}
          elements={elements}
          loginUser={loginUser}
          changeType={changeType}
          changeTypeAt={changeTypeAt}
          clientSecret={clientSecret}
          studentPlanId={studentPlanId}
          subscriptionId={subscriptionId}
          setModalAlert={setModalAlert}
        />
      )}
    </ElementsConsumer>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    login: (data) => dispatch(loginCheckout(data)),
  };
};

export default connect(null, mapDispatchToProps)(InjectedCheckoutForm);
